import { FormControl, FormControlLabel, FormHelperText, FormLabel, Radio, RadioGroup } from "@material-ui/core";
import React from "react";
interface RadioGroup {
  readonly radioList: {
    id: string;
    label: string;
    value: string;
  }[];
  readonly value?: string;
  readonly setValue: (value: string) => void;
  readonly header?: string;
  readonly error?: string;
  readonly disabled?: boolean;
}

function CustomRadioGroup(props: RadioGroup) {
  const { radioList = [], value, setValue, header, error, disabled } = props;
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue((event.target as HTMLInputElement).value);
  };
  return (
    <FormControl component="fieldset" disabled={disabled}>
      <FormLabel style={{ textAlign: "left", fontSize: "12px", color: "#77776E", fontWeight: 600 }}>{header}</FormLabel>
      <RadioGroup row aria-label="radio-group" name="radio" value={value} onChange={handleChange} style={{height:'30px'}}>
        {radioList.map((item: { id: string; label: string; value: string }) => (
          <FormControlLabel key={item.id} value={item.value} control={<Radio color="primary" />} label={item.label} />
        ))}
      </RadioGroup>
      <FormHelperText style={{ fontWeight: "400", color: "red", fontSize: "14px" }}>{error}</FormHelperText>
    </FormControl>
  );
}

export default CustomRadioGroup;
